<button
  (click)="click()"
  [type]="type"
  class="h3-bold btn btn-primary btn-{{ size }} type-{{ Type }}"
  [disabled]="disabled"
  [ngClass]="{ focus: active }"
  [class.alert-btn]="alert"
  [class.success-btn]="success"
  aria-label="button"
  role="button">
  <span class="left-icon btn-icon d-flex">
    <app-ce-icon
      [name]="IconType"
      [ngClass]="{ 'loader-spin': IconType === 'loader' || loading }"
      [svg_class]="['d-flex']"></app-ce-icon>
  </span>
  @if (Type !== 'onlyIcon') {
    <span class="lable_name">{{ label }}</span>
  }
  @if (shortcutKey) {
    <span class="key-btn btn-icon right-icon h4-reg">{{ keyName }}</span>
  }
  @if (Type === 'rightIcon') {
    <app-ce-icon
      [class.d-none]="shortcutKey"
      [name]="IconType"
      [svg_class]="['d-flex']"></app-ce-icon>
  }
</button>
